<!--抄表业主管理小div-->
<template>
	<div class="meterOwerDivBody">
          <div class="meterOwerIcon" :style="iconStyle">
          	<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/meterOnline.png')" alt="" />
          </div>
         <div class="meterOwerDescription">
         	<p>{{name}}</p>
         	<p>{{value}}</p>
			<button class="operateBtn" v-if="isBalance" @click="$emit('chargeMoney')">充值</button>
         </div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			name: {
				type: String
			},
			value:{
				type:[String, Number],
			},
			keyName:{
				type:String
			},
			iconColor:{
				type:String
			}
		},
		data() {
			return {}
		},
		created() {},
		mounted() {
		},
		destroyed() {},
		computed: {
			iconStyle(){
				return {'background-color':this.iconColor}
			},
			isBalance() {
				return this.keyName == 'balance'
			}
		},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
   .meterOwerIcon{
   	  width:50%;
   	  height:38%;
   	  border-radius: 50%;
   	  display: flex;
   	  align-items: center;
   	  justify-content: center;
   }
   .meterOwerDescription p{
   	text-align: center;
   	padding-top: .15rem;
   }
   .operateBtn{
	   height: 30px;
	   padding: 0 10px;
	   border: solid 1px #3BB1FF;
	   color: #3BB1FF;
	   background-color: #ECF5FF;
	   border-radius: 4px;
	   cursor: pointer;
   }
</style>
